import React from "react";
import PropTypes from "prop-types";
import { FormControl, TextField } from "@mui/material";
import { getConfig } from "../../config";
import { renderAgreementStatus } from "./userProfileHelpers";
import { BusinessSectionFields } from "./FormFields";
import VerifiedIcon from "@mui/icons-material/Verified";
import WarningIcon from "@mui/icons-material/Warning";
import CampaignIcon from "@mui/icons-material/Campaign";

export const BusinessFormSection = ({
  businessSection,
  businessReadOnly,
  countryOfReg,
  handleCountryChange,
  countries,
  inputCountryRegErrMsg,
  address,
  handleFieldChange,
  inputAddressErrMsg,
  corporateCompanyCity,
  inputCorporateCompanyCity,
  corporateCompanyState,
  inputCorporateCompanyState,
  isOemAdmin,
  corporateCompanyZip,
  inputCorporateCompanyZip,
  countryOfCompany,
  inputCountryCompanyErrMsg,
  companyPhoneNumber,
  setCompanyPhoneNumber,
  companyEmail,
  inputCompanyEmailErrMsg,
  readOnlyValue,
  privacyPolicy,
  inputPrivacyLinkErrMsg,
  agreementDetails,
  agreementDetailsData,
  agreementStatus,
  handleViewDeveloperAgreement,
  setAddress,
  setCorporateCompanyCity,
  setCorporateCompanyState,
  setCorporateCompanyZip,
  setCompanyEmail,
  setPrivacyPolicy
}) => {
  const isIdpLogin = sessionStorage.getItem("idpLogin") === "true";
  const isSeller = getConfig().REACT_APP_PORTAL === "seller";

  return (
    <>
      <BusinessSectionFields
        businessSection={businessSection}
        businessReadOnly={businessReadOnly}
        countryOfReg={countryOfReg}
        handleCountryChange={handleCountryChange}
        countries={countries}
        inputCountryRegErrMsg={inputCountryRegErrMsg}
        address={address}
        handleAddressChange={handleFieldChange(setAddress, "Address")}
        inputAddressErrMsg={inputAddressErrMsg}
        corporateCompanyCity={corporateCompanyCity}
        handleCityChange={handleFieldChange(setCorporateCompanyCity, "Corporate Company City")}
        inputCorporateCompanyCity={inputCorporateCompanyCity}
        corporateCompanyState={corporateCompanyState}
        handleStateChange={handleFieldChange(setCorporateCompanyState, "Corporate Company State")}
        inputCorporateCompanyState={inputCorporateCompanyState}
        isOemAdmin={isOemAdmin}
        corporateCompanyZip={corporateCompanyZip}
        handleZipChange={handleFieldChange(setCorporateCompanyZip, "Corporate Company Zip")}
        inputCorporateCompanyZip={inputCorporateCompanyZip}
        countryOfCompany={countryOfCompany}
        inputCountryCompanyErrMsg={inputCountryCompanyErrMsg}
        companyPhoneNumber={companyPhoneNumber}
        setCompanyPhoneNumber={setCompanyPhoneNumber}
        companyEmail={companyEmail}
        handleCompanyEmailChange={handleFieldChange(setCompanyEmail, "Company Email")}
        inputCompanyEmailErrMsg={inputCompanyEmailErrMsg}
      />
      <div className="accountControlCls">
        {!isIdpLogin && businessSection && (
          <FormControl
            style={{
              display: "flex",
              flexDirection: "column",
              width: "100%",
            }}
          >
            <label className="labelName">
              Privacy Policy{" "}
              <span
                style={{
                  color: "red",
                  display: isOemAdmin && "none",
                }}
              >
                *
              </span>
            </label>
            <TextField
              className="inputCls"
              disabled={readOnlyValue}
              autoComplete="off"
              placeholder="https://"
              fullWidth
              sx={{
                ".MuiInputBase-input": {
                  fontSize: "14px !important",
                },
              }}
              id="privacyPolicy"
              value={privacyPolicy}
              onChange={handleFieldChange(setPrivacyPolicy, "Privacy Policy")}
              slotProps={{
                input: {
                  readOnly: readOnlyValue,
                },
              }}
            />
            {inputPrivacyLinkErrMsg && (
              <span style={{ color: "red", fontSize: "12px" }}>
                {inputPrivacyLinkErrMsg}
              </span>
            )}
          </FormControl>
        )}
      </div>
      {businessSection && !isIdpLogin && isSeller && (
        <div className="agreementMsg">
          <div className="developerAgreementTxt">
            Developer Agreement <span style={{ color: "red" }}>*</span>
          </div>
          {renderAgreementStatus(agreementDetails, agreementDetailsData, agreementStatus, VerifiedIcon, WarningIcon, CampaignIcon)}
          <button
            type="button"
            className="viewAgreementCls"
            onClick={handleViewDeveloperAgreement}
          >
            View Developer Agreement
          </button>
        </div>
      )}
      {businessSection && (
        <div>
          <p className="disclaimer-text-data">
            <span className="disclaimer-text">Disclaimer:</span>The
            information you enter will be visible to the end
            user(driver). Please ensure that all content is accurate,
            appropriate, and does not contain any confidential or
            sensitive data unless authorized for sharing.
          </p>
        </div>
      )}
    </>
  );
};

BusinessFormSection.propTypes = {
  businessSection: PropTypes.bool,
  businessReadOnly: PropTypes.bool,
  countryOfReg: PropTypes.string,
  handleCountryChange: PropTypes.func.isRequired,
  countries: PropTypes.array,
  inputCountryRegErrMsg: PropTypes.string,
  address: PropTypes.string,
  handleFieldChange: PropTypes.func.isRequired,
  inputAddressErrMsg: PropTypes.string,
  corporateCompanyCity: PropTypes.string,
  inputCorporateCompanyCity: PropTypes.string,
  corporateCompanyState: PropTypes.string,
  inputCorporateCompanyState: PropTypes.string,
  isOemAdmin: PropTypes.bool,
  corporateCompanyZip: PropTypes.string,
  inputCorporateCompanyZip: PropTypes.string,
  countryOfCompany: PropTypes.string,
  inputCountryCompanyErrMsg: PropTypes.string,
  companyPhoneNumber: PropTypes.string,
  setCompanyPhoneNumber: PropTypes.func.isRequired,
  companyEmail: PropTypes.string,
  inputCompanyEmailErrMsg: PropTypes.string,
  readOnlyValue: PropTypes.bool,
  privacyPolicy: PropTypes.string,
  inputPrivacyLinkErrMsg: PropTypes.string,
  agreementDetails: PropTypes.object,
  agreementDetailsData: PropTypes.object,
  agreementStatus: PropTypes.bool,
  handleViewDeveloperAgreement: PropTypes.func.isRequired,
  setAddress: PropTypes.func.isRequired,
  setCorporateCompanyCity: PropTypes.func.isRequired,
  setCorporateCompanyState: PropTypes.func.isRequired,
  setCorporateCompanyZip: PropTypes.func.isRequired,
  setCompanyEmail: PropTypes.func.isRequired,
  setPrivacyPolicy: PropTypes.func.isRequired
};
